<template>
  <v-col
    v-if="componente"
    :cols="value.colunas"
  >
    <component
      :is="componente"
      :value="value"
    >
      <template v-slot:children>
        <component
          :is="getComponente(filho.tipo)"
          v-for="(filho, i) in value.filhos"
          v-show="
            !value.filhosDependentes || (value.filhosDependentes && value.opcao)
          "
          :key="i"
          :value="filho"
          :disable="
            !value.habilitado ||
              (value.filhosDependentes && value.opcao === false)
          "
        />
      </template>
    </component>
  </v-col>
</template>

<script>
import FiltroUnidade from '@/components/monitoramento/perfil/filtro/base/FiltroUnidade';
import FiltroSelect from '@/components/monitoramento/perfil/filtro/base/FiltroSelect';
import FiltroConfirm from '@/components/monitoramento/perfil/filtro/base/FiltroConfirm';
import FiltroTime from '@/components/monitoramento/perfil/filtro/base/FiltroTime';
import FiltroExtra from '@/components/monitoramento/perfil/filtro/base/FiltroExtra';

export default {
  name: 'Filtro',

  components: {
    FiltroUnidade,
    FiltroSelect,
    FiltroConfirm,
    FiltroTime,
    FiltroExtra,
  },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  computed: {
    componente() {
      return this.getComponente(this.value.tipo);
    },
  },

  methods: {
    getComponente(tipo) {
      switch (tipo) {
        case 'unidade':
          return 'FiltroUnidade';
        case 'select':
          return 'FiltroSelect';
        case 'confirm':
          return 'FiltroConfirm';
        case 'time':
          return 'FiltroTime';
        case 'extra':
          return 'FiltroExtra';
        default:
          return null;
      }
    },
  },
};
</script>
